import {
  FETCH_TLOG_DATA_REQUEST,
  FETCH_TLOG_DATA_SUCCESS,
  FETCH_TLOG_DATA_FAILURE,
} from "./types";

export const fetchTlogDataRequest = () => ({
  type: FETCH_TLOG_DATA_REQUEST,
});

export const fetchTlogDataSuccess = (data) => ({
  type: FETCH_TLOG_DATA_SUCCESS,
  payload: data,
});

export const fetchTlogDataFailure = (error) => ({
  type: FETCH_TLOG_DATA_FAILURE,
  payload: error,
});
